export default "__VITE_ASSET__BpFiolQO__"